"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeInfo = void 0;
var TypeInfo;

(function (TypeInfo) {
  /**
   * 앱 정보를 요청해요
   */
  TypeInfo["ReqInfoApp"] = "REQ.INFO.APP";
  /**
   * 리전 정보를 요청해요
   */

  TypeInfo["ReqInfoRegion"] = "REQ.INFO.REGION";
  /**
   * 유저 정보를 요청해요
   */

  TypeInfo["ReqInfoUser"] = "REQ.INFO.USER";
  /**
   * 리전 이름 정보를 요청해요
   * (써드파티 사용 가능)
   */

  TypeInfo["ReqInfoRegionName"] = "REQ.INFO.REGION_NAME";
  /**
   * 앱 정보를 반환해요
   * @required app  앱 정보
   */

  TypeInfo["ResInfoApp"] = "RES.INFO.APP";
  /**
   * 리전 정보를 반환해요
   * @required region 리전 정보
   */

  TypeInfo["ResInfoRegion"] = "RES.INFO.REGION";
  /**
   * 유저 정보를 반환해요
   * @required user 유저 정보
   */

  TypeInfo["ResInfoUser"] = "RES.INFO.USER";
  /**
   * 리전 이름 정보를 반환해요
   * @required regionName 지역 이름 정보
   */

  TypeInfo["ResInfoRegionName"] = "RES.INFO.REGION_NAME";
})(TypeInfo = exports.TypeInfo || (exports.TypeInfo = {}));